<template>
  <Container gray>
    <div class="row">
      <div class="col">
        <div class="title">
          <StrongText>Ficou com alguma dúvida? Fale conosco.</StrongText>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <Alert
          success
          v-if="alert.success.show"
          v-html="alert.success.text"
        />
        <Alert
          error
          v-if="alert.error.empty.show"
          v-html="alert.error.empty.text"
        />
        <Alert
          error
          v-if="alert.error.server.show"
          v-html="alert.error.server.text"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <Input @keydown="removeAlertas" v-model="name" label="Nome"/>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg">
        <Input @keydown="removeAlertas" v-model="email" label="Email"/>
      </div>
      <div class="col-12 col-lg">
        <Input v-mask="['(##) #### ####', '(##) ##### ####']" @keydown="removeAlertas" v-model="phone" type="tel" label="Contato Whatsapp"/>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <Textarea @keydown="removeAlertas" v-model="message" label="Mensagem"/>
      </div>
    </div>
    <div class="row text-center">
      <div class="col">
        <span @click="envia">
          <Button big>Enviar</Button>
        </span>
        <span class="alternative" :style="style.alternative">Ou mande um email para corrida@dinamicaproducoes.com.br</span>
      </div>
    </div>
  </Container>
</template>

<script>
import api from '@/services/api'
import Alert from '@/components/Alert'
import Container from '@/components/Container'
import StrongText from '@/components/StrongText'
import Input from '@/components/Input'
import Textarea from '@/components/Textarea'
import Button from '@/components/Button'
import colors from '@/services/colors'

export default {
  name: 'FormPerguntasFrequentes',
  components: {
    StrongText,
    Input,
    Container,
    Textarea,
    Button,
    Alert,
  },
  data: () => ({
    name: '',
    email: '',
    phone: '',
    message: '',
    alert: {
      success: {
        show: false,
        text: 'Mensagem enviada com sucesso! Entraremos em contato o quanto antes.',
      },
      error: {
        empty: {
          show: false,
          text: 'Preencha todos os campos!',
        },
        server: {
          show: false,
          text: 'Houve algum problema! Enquanto arrumamos, envie sua dúvida para o email: <strong style="font-weight: 600;">corrida@dinamicaproducoes.com.br</strong>',
        },
      }
    }
  }),
  methods: {
    removeAlertas() {
      this.alert.success.show = false
      this.alert.error.empty.show = false
      this.alert.error.server.show = false
    },
    async envia() {
      this.alert.success.show = false
      this.alert.error.empty.show = false

      const camposPreenchidos = this.name && this.email && this.phone && this.message
      if(!camposPreenchidos)
        return this.alert.error.empty.show = true

      try {

        await api.sendMessage({
          name: this.name,
          email: this.email,
          phone: this.phone,
          message: this.message,
        })

        this.alert.success.show = true
        this.name = ''
        this.email = ''
        this.phone = ''
        this.message = ''

      } catch (error) {
        this.alert.error.server.show = true
      }

    }
  },
  computed: {
    style() {
      return {
        alternative: {
          color: colors.blue
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  margin-bottom: 26px;
}
.text-center {
  text-align: center;
}
.alternative {
  display: block;
  font-size: 14px;
  margin-top: 35px;
  font-weight: 500;
}

.alert {

  padding: 20px;
  margin-bottom: 20px;
  font-weight: 300;

  &.success {
    $color: #2ecc71;
    background: $color;
    color: darken($color, 20%)
  }
  &.error {
    $color: #eb2136;
    background: $color;
    color: darken($color, 20%)
  }
}
</style>
